import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Close menu on navigation
  const handleNavClick = () => setMobileMenuOpen(false);

  return (
    <nav style={{
      background: 'rgb(17, 17, 17)',
      borderBottom: '1px solid rgb(51, 51, 51)',
      padding: '1rem 0px',
      position: 'sticky',
      top: '0px',
      zIndex: 1000,
      backdropFilter: 'blur(10px)'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0px auto',
        padding: '0px 2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem'
        }}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <div style={{ width: '56px', height: '56px' }}>
              <img 
                src="/images/ChatGPT_Image_Jun_5__2025__01_11_15_PM-removebg-preview.png" 
                alt="Fullness Life Logo" 
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  transition: 'transform 0.3s'
                }}
              />
            </div>
          </Link>
          <Link 
            to="/" 
            style={{
              color: 'rgb(245, 245, 220)',
              textDecoration: 'none',
              fontSize: '1.5rem',
              fontWeight: '600',
              letterSpacing: '0.02em'
            }}
          >
            Fullness Life
          </Link>
        </div>
        {/* Hamburger icon for mobile */}
        <div style={{ display: 'none', cursor: 'pointer' }} className="navbar-hamburger" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="7" width="32" height="3" rx="1.5" fill="#f5f5dc" />
            <rect y="14.5" width="32" height="3" rx="1.5" fill="#f5f5dc" />
            <rect y="22" width="32" height="3" rx="1.5" fill="#f5f5dc" />
          </svg>
        </div>
        {/* Desktop nav links */}
        <div className="navbar-links" style={{
          display: 'flex',
          gap: '2rem',
          alignItems: 'center'
        }}>
          <Link 
            to="/wellness" 
            style={{
              color: 'rgb(245, 245, 220)',
              textDecoration: 'none',
              padding: '0.5rem 1rem',
              borderRadius: '4px',
              transition: '0.3s'
            }}
            onClick={handleNavClick}
          >
            Wellness
          </Link>
          <Link 
            to="/ai-tech" 
            style={{
              color: 'rgb(245, 245, 220)',
              textDecoration: 'none',
              padding: '0.5rem 1rem',
              borderRadius: '4px',
              transition: '0.3s',
            }}
            onClick={handleNavClick}
          >
            AI & Technology
          </Link>
          <Link 
            to="/finance" 
            style={{
              color: 'rgb(245, 245, 220)',
              textDecoration: 'none',
              padding: '0.5rem 1rem',
              borderRadius: '4px',
              transition: '0.3s'
            }}
            onClick={handleNavClick}
          >
            Finance
          </Link>
        </div>
        {/* Mobile dropdown menu */}
        {mobileMenuOpen && (
          <div className="navbar-mobile-dropdown" style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            background: 'rgb(17, 17, 17)',
            border: '1px solid rgb(51, 51, 51)',
            borderRadius: '8px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
            display: 'flex',
            flexDirection: 'column',
            minWidth: '180px',
            zIndex: 2000
          }}>
            <Link to="/wellness" style={{ padding: '1rem', color: 'rgb(245, 245, 220)', textDecoration: 'none' }} onClick={handleNavClick}>Wellness</Link>
            <Link to="/ai-tech" style={{ padding: '1rem', color: 'rgb(245, 245, 220)', textDecoration: 'none' }} onClick={handleNavClick}>AI & Technology</Link>
            <Link to="/finance" style={{ padding: '1rem', color: 'rgb(245, 245, 220)', textDecoration: 'none' }} onClick={handleNavClick}>Finance</Link>
          </div>
        )}
        <style>{`
          @media (max-width: 768px) {
            .navbar-links {
              display: none !important;
            }
            .navbar-hamburger {
              display: block !important;
            }
          }
          @media (min-width: 769px) {
            .navbar-mobile-dropdown {
              display: none !important;
            }
          }
        `}</style>
      </div>
    </nav>
  );
};

export default Navbar;
